/**
 * Strings for the first-run screens that offer the starter example
 * (components/dashboard/EmptyState.tsx, the empty Notes list) and for the
 * notices around loading it (hooks/useStarterPack.ts). The example's own
 * cards and note are content, not interface copy: lib/starter/starter-content.ts.
 *
 * Spread into the main catalog; `STARTER_EN` is typed against `STARTER_ES`,
 * so a missing English string fails to compile.
 */

export const STARTER_ES = {
  'starter.empty.title': 'Aún no tienes mazos',
  'starter.empty.lead': 'Carga el ejemplo para ver cómo funciona QUIPWA en unos minutos, o importa tus propias tarjetas.',
  'starter.empty.deck': 'Un mazo sobre cómo estudiar: recuerdo activo, repaso espaciado y qué significa cada valoración.',
  'starter.empty.note': 'Una nota que enseña el editor: enlaces, fórmulas, avisos, plegables y tarjetas desde una selección.',
  'starter.empty.formats': 'Importar admite CSV de NotebookLM y archivos .wflash.',
  'starter.contentsLabel': 'Qué incluye el ejemplo',

  'starter.load': 'Cargar ejemplo',
  'starter.loading': 'Cargando ejemplo…',
  'starter.import': 'Importar',
  'starter.syncNotice': 'Se guarda en este dispositivo como cualquier mazo o nota. Si conectas tu cuenta de Google, se sincroniza con tu Drive. Puedes borrarlo cuando quieras.',

  'starter.loaded': 'Ejemplo listo: {count} tarjetas y una nota de bienvenida.',
  'starter.alreadyLoaded': 'El ejemplo ya estaba cargado.',
  'starter.failed': 'No se pudo cargar el ejemplo. Inténtalo de nuevo.',
  'starter.notReady': 'La base de datos aún no está lista. Espera un momento.',
} as const

export const STARTER_EN: Record<keyof typeof STARTER_ES, string> = {
  'starter.empty.title': 'No decks yet',
  'starter.empty.lead': 'Load the example to see how QUIPWA works in a few minutes, or import your own cards.',
  'starter.empty.deck': 'A deck on how to study: active recall, spaced repetition and what each rating means.',
  'starter.empty.note': 'A note that shows the editor: links, formulas, callouts, toggles and cards from a selection.',
  'starter.empty.formats': 'Import accepts NotebookLM CSV files and .wflash files.',
  'starter.contentsLabel': 'What the example includes',

  'starter.load': 'Load example',
  'starter.loading': 'Loading example…',
  'starter.import': 'Import',
  'starter.syncNotice': 'It is saved on this device like any deck or note. If you connect your Google account, it syncs to your Drive. You can delete it whenever you like.',

  'starter.loaded': 'Example ready: {count} cards and a welcome note.',
  'starter.alreadyLoaded': 'The example was already loaded.',
  'starter.failed': 'Could not load the example. Please try again.',
  'starter.notReady': 'The database is not ready yet. Give it a moment.',
}
